<template>
  <div class="btn-group">
    <li
      @click="toggleMenu()"
      class="dropdown-toggle"
    >
      {{ value.label || placeholder }}
      <chevron
        :rotate="showMenu ? 180 : 90"
        size="s"
        color="white"
      />
    </li>
    <transition name="drop">
      <ul
        class="dropdown-menu"
        v-if="showMenu"
      >
        <li
          v-for="option in options"
          :key="option.label"
        >
          <span @click="input(option)">
            {{ option.label }}
          </span>
        </li>
      </ul>
    </transition>
  </div>
</template>

<script>
import Chevron from '@/components/icons/Chevron'
export default {
  name: 'TwDropdown',
  components: {
    Chevron
  },
  data () {
    return {
      showMenu: false
    }
  },
  props: {
    options: {
      type: Array,
      default: () => { return [] }
    },
    value: {
      type: Object,
      default: () => { return {} }
    },
    placeholder: {
      type: String,
      default: 'Please select an item'
    }
  },
  methods: {
    input (option) {
      this.showMenu = false
      this.$emit('input', option)
    },
    toggleMenu () {
      this.showMenu = !this.showMenu
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/uiColors';

.btn-group {
  min-width: 160px;
  position: relative;
  display: inline-block;
  vertical-align: middle;
  a {
    &:hover {
      text-decoration: none;
    }
  }
}

.dropdown-toggle {
  color: white;
  min-width: 160px;
  text-transform: none;
  background: transparent;
  display: flex;
  justify-content: space-between;
  transition: all 0.3s ease;
  border-bottom: 2px solid transparent;
  float: none;
  box-shadow: none;
  border-radius: 0;
  &:hover {
    border-bottom-color: white;
    cursor: pointer;
  }
}

.dropdown-menu {
  position: absolute;
  min-width: 100%;
  top: 100%;
  left: 0;
  float: left;
  padding: 0;
  margin: 2px 0 0;
  list-style: none;
  font-size: 16px;
  text-align: left;
  background-color: white;
  border-radius: 1px;
  background-clip: padding-box;
  z-index: z(dropDownMenu);
}

.dropdown-menu > li > span {
  padding: 10px 20px;
  display: block;
  clear: both;
  font-weight: normal;
  line-height: 1.6;
  color: #222;
  white-space: nowrap;
  font-weight: 400;

  &:hover {
    background: $color-main;
    color: #fff;
  }
}

.dropdown-menu > li {
  overflow: hidden;
  width: 100%;
  position: relative;
  margin: 0
}
</style>
